import { render, staticRenderFns } from "./AccountSyncErrors.vue?vue&type=template&id=4ff1315a&"
import script from "./AccountSyncErrors.vue?vue&type=script&lang=js&"
export * from "./AccountSyncErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports